import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { CSSTransitionGroup } from "deprecated-react-transition-group";

import Input from "../Input";
import CardIcon from "../CardIcon";

import "./CardInput.scss";

const CardInput = ({ children, className, cardType, ...rest }) => {
	return (
		<Input
			className={classnames(className, {
				"payment-card-input": true,
			})}
			{...rest}
		>
			<CSSTransitionGroup
				transitionName="payment-card-input-animation"
				transitionEnterTimeout={200}
				transitionLeaveTimeout={200}
			>
				{cardType &&
					<CardIcon
						className="payment-card-input-card-icon"
						cardType={cardType}
					/>
				}
			</CSSTransitionGroup>
			{children}
		</Input>
	);
};

CardInput.propTypes = {
	className: PropTypes.string,
	cardType: PropTypes.string,
	children: PropTypes.node,
};

CardInput.defaultProps = {
	className: null,
	cardType: null,
	children: "",
};

export default CardInput;



// WEBPACK FOOTER //
// ./src/apps/payment/components/CardInput/index.jsx